/**
 * @flow
 * @format
 */

import _SchematicWrapper from './SchematicWrapper';

export default _SchematicWrapper;



// WEBPACK FOOTER //
// ./src/components/SchematicWrapper/index.js